import React, { useState, useEffect } from "react";
import { CognitoAuth } from "../Utils/cognito-auth";
import { Button, Form, Alert } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../LogIn/LogIn.css";
import { Row, Col, Container } from "react-bootstrap";
import "./ForgotPassword.css"; // Import custom CSS file for styling

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [stage, setStage] = useState(1); // To toggle between request code and reset password steps
  const [emailError, setEmailError] = useState(""); // Email validation error message

  const { userPool, createCognitoUser } = CognitoAuth(true, true, true);

  // Email validation regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Email validation effect
  useEffect(() => {
    if (email && !emailRegex.test(email)) {
      setEmailError("Please enter a valid email address.");
    } else {
      setEmailError(""); // Clear error if email is valid
    }
  }, [email]);

  // Step 1: Request Verification Code
  const requestVerificationCode = () => {
    const user = createCognitoUser(email, userPool);

    user.forgotPassword({
      onSuccess: () => {
        setMessage(
          "If the email is registered, you will receive a verification code. Please check your inbox or spam folder."
        );
        setStage(2); // Move to the next stage to enter the verification code
      },
      onFailure: (err) => {
        setMessage(`Error: ${err.message || JSON.stringify(err)}`);
      },
    });
  };

  // Step 2: Reset Password using the verification code
  const resetPassword = () => {
    const user = createCognitoUser(email, userPool);

    user.confirmPassword(verificationCode, newPassword, {
      onSuccess: () => {
        setMessage(
          "Password reset successful! You can now log in with your new password."
        );
      },
      onFailure: (err) => {
        setMessage(`Error: ${err.message || JSON.stringify(err)}`);
      },
    });
  };

  return (
    <div className="forum-page">
      <Container style={{ width: "100%" }}>
        <Row style={{ height: "20px" }}></Row>
        <Row>
          <Col lg={12} md={12} sm={12} xs={12}>
            <div className="Auth-form-container d-flex align-items-center justify-content-center">
              <div className="Auth-form-content" style={{ border: "1px solid #ddd", borderRadius: "8px", padding: "30px" }}>
                <h2 className="text-heading Auth-form-title">Forgot Password</h2>
                <Form noValidate>
                  {message && <Alert variant="info">{message}</Alert>}

                  {stage === 1 && (
                    <>
                      <div
                        className="Auth-form-container d-flex align-items-center justify-content-center"
                        id="signInSection"
                        style={{ width: "100%" }}
                      >
                        <Form.Group controlId="email">
                          <Row style={{ padding: "5px" }}>
                            <Col
                              lg={3}
                              md={3}
                              sm={3}
                              xs={3}
                              style={{
                                marginTop: "10px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <Form.Label style={{ fontFamily: "Arial, sans-serif", fontSize: "13px", whiteSpace: "nowrap" }}>
                                Email Address
                              </Form.Label>
                            </Col>
                            <Col lg={9} md={9} sm={9} xs={9}>
                              <Form.Control
                                type="email"
                                placeholder="Enter email address"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                style={{ width: "100%" }}
                              />
                              {emailError && (
                                <Form.Text className="text-danger">{emailError}</Form.Text>
                              )}
                            </Col>
                          </Row>
                        </Form.Group>
                      </div>
                      <div className="d-grid gap-2 mt-3">
                        <Button
                          variant="primary"
                          onClick={requestVerificationCode}
                          disabled={!email || emailError}
                          style={{ width: "100%", whiteSpace: "nowrap", backgroundColor: "#4CAF50" }}
                        >
                          Send Verification Code
                        </Button>
                      </div>
                    </>
                  )}

                  {stage === 2 && (
                    <>
                      <Form.Group controlId="verificationCode">
                        <Row style={{ padding: "5px" }}>
                          <Col
                            lg={6}
                            md={6}
                            sm={6}
                            xs={6}
                            style={{ marginTop: "10px" }}
                          >
                            <Form.Label>Enter Verification Code</Form.Label>
                          </Col>
                          <Col lg={6} md={6} sm={6} xs={6}>
                            <Form.Control
                              type="text"
                              placeholder="Enter verification code"
                              value={verificationCode}
                              onChange={(e) => setVerificationCode(e.target.value)}
                              required
                              style={{ width: "100%" }}
                            />
                          </Col>
                        </Row>
                      </Form.Group>

                      <Form.Group controlId="newPassword">
                        <Row style={{ padding: "5px" }}>
                          <Col
                            lg={6}
                            md={6}
                            sm={6}
                            xs={6}
                            style={{ marginTop: "10px" }}
                          >
                            <Form.Label>Enter New Password</Form.Label>
                          </Col>
                          <Col lg={6} md={6} sm={6} xs={6}>
                            <Form.Control
                              type="password"
                              placeholder="Enter new password"
                              value={newPassword}
                              onChange={(e) => setNewPassword(e.target.value)}
                              required
                              style={{ width: "100%" }}
                            />
                          </Col>
                        </Row>
                      </Form.Group>

                      <div className="d-grid gap-2 mt-3">
                      <Button
                        variant="primary"
                        onClick={resetPassword}
                        disabled={!verificationCode || !newPassword}
                        style={{ width: "100%", whiteSpace: "nowrap", backgroundColor: "#4CAF50" }}
                      >
                          Reset Password
                        </Button>
                      </div>
                    </>
                  )}
                </Form>
              </div>
            </div>
          </Col>
        </Row>
        <Row style={{ height: "20px" }}></Row>
      </Container>
    </div>
  );
}

export default ForgotPassword;
